import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '../forms/forms.module';
import { IconButtonModule } from '../icon-buttons/icon-button.module';
import { AdminFormFieldComponent } from './admin-form-field.component';
import { AsideItemWithOverlayComponent } from './aside-item/aside-item-with-overlay.component';
import { PortalLinkDirective } from './portal-link.directive';
import { ViewComponent } from './view.component';

const EXPORTED_COMPONENTS = [
    AsideItemWithOverlayComponent,
    AdminFormFieldComponent,
    ViewComponent,
    PortalLinkDirective
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        OverlayModule,
        FormsModule,
        IconButtonModule
    ],
    declarations: [
        ...EXPORTED_COMPONENTS
    ],
    exports: [
        ...EXPORTED_COMPONENTS
    ]
})
export class PortalApiModule {
}
